import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import DataWarehousing from '../MenserviceDataWarehousing/DataWarehousing'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Data Warehousing Services" />
                <DataWarehousing />
                <Footer />
            </div>
        </>
    )
}

export default Main